module.exports = __webpack_public_path__ + "static/media/CLASS2.d31b850a.jpg";